<template>
  <div>
    <QuotationSelectModality
      @modality="getModality"
      :model="selectedValueStepModality.modality"
      :list="listModality"
    />
    <QuotationSelectSubModality
      @subModality="getSubModality"
      v-if="selectedValueStepModality.modality"
      :model="selectedValueStepModality.subModality"
      :list="listSubModality"
    />
    <QuotationSelectEmissionType
      @emission="getEmissionType"
      v-if="selectedValueStepModality.subModality"
      :model="selectedValueStepModality.emissionType"
      :items="optionsQuotation.tipos_emissao"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotationButton"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>
<script>
import QuotationSelectModality from "../components/QuotationSelectModality";
import QuotationSelectSubModality from "../components/QuotationSelectSubModality";
import QuotationSelectEmissionType from "../components/QuotationSelectEmissionType";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  name: "QuotationStepModality",
  data: () => ({
    selectedValueStepModality: {}
  }),
  mounted() {
    this.getValueStepModality();
  },
  components: {
    QuotationSelectModality,
    QuotationSelectSubModality,
    QuotationSelectEmissionType
  },
  mixins: [QuotationMixin, LoadingRequest],
  computed: {
    ...mapState("quotation", ["listModality", "listSubModality"]),
    nextQuotationStep() {
      return {
        name: "quotation step company",
        step: 2
      };
    }
  },
  created() {
    this.fetchModalities();
  },
  methods: {
    ...mapActions("quotation", [
      "requestModalities",
      "requestSubModalities",
      "requestOptionsQuotation"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    fetchModalities() {
      this.withLoading(this.requestModalities());
    },
    fetchSubModalities(item) {
      this.withLoading(this.requestSubModalities(item.id));
      this.selectedValueStepModality.modality = item;
      const element = document.getElementById("submodality");
      if (element) {
        element.scrollIntoView();
      }
    },
    getValueStepModality() {
      // Caso retorne os passos anteriores, preciso pegar as informações
      // que já foram selecionadas.
      this.selectedValueStepModality = { ...this.form };
    },
    getModality(item) {
      this.selectedValueStepModality.subModality = null;
      this.fetchSubModalities(item);
    },
    getSubModality(item) {
      this.selectedValueStepModality.subModality = item;
      this.withLoading(
        this.requestOptionsQuotation(item.id).then(item => {
          this.$emit("updateOptions", item);
          const element = document.getElementById("emission");
          if (element) {
            element.scrollIntoView();
          }
        })
      );
    },
    getEmissionType(item) {
      this.selectedValueStepModality.emissionType = item;
      // Salvar informações no componente pai, caso ele retorne nesse etapa.
      // Não terá integração com back-end até terminar o processo.
      this.$emit(
        "updateStep",
        this.payloadQuotation(
          this.selectedValueStepModality,
          this.nextQuotationStep
        )
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.quotation-title
  font-size: 18px
</style>
